import { combineReducers } from 'redux'
import userReducer from './reducers/userReducer'
import cityReducer from './reducers/cityReducer'
import loginReducer from './reducers/loginReducer'
import patientReducer from './reducers/patientReducer'
import packageReducer from './reducers/packageReducer'
import cartReducer from './reducers/cartReducer'
import orderReducer from './reducers/orderReducer'
import commonReducer from './reducers/commonReducer'

const rootReducer = combineReducers({
  user: userReducer,
  city: cityReducer,
  login: loginReducer,
  patient: patientReducer,
  package: packageReducer,
  cart: cartReducer,
  order: orderReducer,
  common: commonReducer,
})

export default rootReducer
